// extracted by mini-css-extract-plugin
export default {"head":"DocumHead_head__RMu4v","type":"DocumHead_type__z0lUJ","name":"DocumHead_name__Z5vQQ","documents":"DocumHead_documents__L21im"};